import React from 'react'
import {Icon} from '@chakra-ui/react'

const EditIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" id="edit" {...props}>
            <path
                d="M7.68049 38.9904L1.99457 38.9434C1.4879 38.9434 1.06568 38.5306 1.06568 38.0146L1 32.3192C1 32.0659 1.09383 31.822 1.2721 31.6437L31.0435 1.87233C32.2163 0.699491 34.1116 0.708874 35.2844 1.87233L38.118 4.70591C38.681 5.26887 39 6.02887 39 6.8264C39 7.62394 38.6904 8.38394 38.118 8.9469L8.34667 38.7183C8.1684 38.8965 7.93383 38.9904 7.68049 38.9904ZM2.92346 37.0763L7.2958 37.1138L36.7857 7.61455C37.0015 7.39875 37.1141 7.11727 37.1141 6.8264C37.1141 6.53554 37.0015 6.24468 36.7857 6.03826L33.9521 3.20468C33.5111 2.76369 32.8074 2.76369 32.3664 3.20468L2.87654 32.6946L2.92346 37.0763Z"
                fill="currentColor"
            />
            <path
                d="M32.2637 14.2012C32.0292 14.2012 31.7946 14.1168 31.6069 13.9385L25.8835 8.35581C25.5082 7.98989 25.5082 7.39878 25.8647 7.03285C26.2306 6.65754 26.8218 6.65754 27.1877 7.01408L32.9111 12.5968C33.2864 12.9627 33.2864 13.5538 32.9299 13.9198C32.7422 14.1074 32.4983 14.2012 32.2543 14.2012H32.2637Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default EditIcon
